// src/data/bookTOC.ts
import Introduction from "../bookPages/Introduction/Introduction";

import Rebuild from "../bookPages/Rebuild/Rebuild";
import RevereGod from "../bookPages/Rebuild/RevereGod";
import Repent from "../bookPages/Rebuild/Repent";
import RemoveStumblingBlocks from "../bookPages/Rebuild/RemoveStumblingBlocks";
import RenewMind from "../bookPages/Rebuild/RenewMind";
import RekindleLove from "../bookPages/Rebuild/RekindleLove";
import Rededicate from "../bookPages/Rebuild/Rededicate";
import RegainSpirit from "../bookPages/Rebuild/RegainSpirit";
import RecommitObedience from "../bookPages/Rebuild/RecommitObedience";
import ReadyForTemptation from "../bookPages/Rebuild/ReadyForTemptation";
import ReinforceWithPrayer from "../bookPages/Rebuild/ReinforceWithPrayer";
import RecruitAccountability from "../bookPages/Rebuild/RecruitAccountability";
import RestInTheLord from "../bookPages/Rebuild/RestInTheLord";

import Resist from "../bookPages/Resist/Resist";
import RecognizeTemptation from "../bookPages/Resist/RecognizeTemptation";
import RealizeConsequences from "../bookPages/Resist/RealizeConsequences";
import RememberPain from "../bookPages/Resist/RememberPain";
import ReciteScripture from "../bookPages/Resist/ReciteScripture";
import RefuseTemptation from "../bookPages/Resist/RefuseTemptation";
import RetreatFromTemptation from "../bookPages/Resist/RetreatFromTemptation";
import ReckonDeadToSin from "../bookPages/Resist/ReckonDeadToSin";
import RequestHelp from "../bookPages/Resist/RequestHelp";
import ResolveToOvercome from "../bookPages/Resist/ResolveToOvercome";
import ReplaceFleshlyThoughts from "../bookPages/Resist/ReplaceFleshlyThoughts";
import RejoiceInBlessings from "../bookPages/Resist/RejoiceInBlessings";
import ReverseMomentum from "../bookPages/Resist/ReverseMomentum";
import { Component } from "react";

export interface PageNode {
    title: string;
    slug: string;
    subchapters?: PageNode[];
}

export const bookTOC = [
    {
      title: "Introduction",
      slug: "introduction",
      Component: Introduction,
    },
    {
        title: "Rebuild Your Relationship With the LORD",
        slug: "rebuild-your-relationship",
        Component: Rebuild,
      subchapters: [
        {
          title: "Revere God and fear Him.",
          slug: "revere-god",
          Component: RevereGod,
        },
        {
          title: "Repent and confess your sins to God.",
          slug: "repent",
          Component: Repent,
        },
        {
          title: "Remove anything from your surroundings that makes you stumble.",
          slug: "remove-stumbling-blocks",
          Component: RemoveStumblingBlocks,
        },
        {
          title: "Renew your mind daily in the Word of God.",
          slug: "renew-mind",
          Component: RenewMind,
        },
        {
          title: "Rekindle a zealous love for the Lord.",
          slug: "rekindle-love",
          Component: RekindleLove,
        },
        {
          title: "Rededicate yourself to God as a living sacrifice.",
          slug: "rededicate",
          Component: Rededicate,
        },
        {
          title: "Regain the fullness of the Spirit.",
          slug: "regain-spirit",
          Component: RegainSpirit,
        },
        {
          title: "Recommit yourself to full obedience and service to God.",
          slug: "recommit-obedience",
          Component: RecommitObedience,
        },
        {
          title: "Ready yourself and prepare for temptation.",
          slug: "ready-for-temptation",
          Component: ReadyForTemptation,
        },
        {
          title: "Reinforce the defenses with unceasing prayer.",
          slug: "reinforce-with-prayer",
          Component: ReinforceWithPrayer,
        },
        {
          title: "Recruit an accountability partner.",
          slug: "recruit-accountability",
          Component: RecruitAccountability,
        },
        {
          title: "Rest in the Lord, trust Him completely, and wait patiently for Him.",
          slug: "rest-in-the-lord",
          Component: RestInTheLord,
        },
      ],
    },
    {
      title: "Resist Temptation When it Comes",
      slug: "resist-temptation",
      Component: Resist,
      subchapters: [
        {
          title: "Recognize temptation; do not be ignorant as to what sin is and how you are tempted.",
          slug: "recognize-temptation",
          Component: RecognizeTemptation,
        },
        {
          title: "Realize the potential consequences and opportunity temptation brings.",
          slug: "realize-consequences",
          Component: RealizeConsequences,
        },
        {
          title: "Remember the pain, destruction, wrath, and judgment that results from sin.",
          slug: "remember-pain",
          Component: RememberPain,
        },
        {
          title: "Recite Scripture and rebuke evil in the Name of the Lord.",
          slug: "recite-scripture",
          Component: ReciteScripture,
        },
        {
          title: "Refuse temptation immediately, decisively, and persistently.",
          slug: "refuse-temptation",
          Component: RefuseTemptation,
        },
        {
          title: "Retreat immediately from sources of temptation; FLEE!",
          slug: "retreat-from-temptation",
          Component: RetreatFromTemptation,
        },
        {
          title: "Reckon yourself to be dead to sin and alive to God.",
          slug: "reckon-dead-to-sin",
          Component: ReckonDeadToSin,
        },
        {
          title: "Request God to help you.",
          slug: "request-help",
          Component: RequestHelp,
        },
        {
          title: "Resolve to overcome at all costs.",
          slug: "resolve-to-overcome",
          Component: ResolveToOvercome,
        },
        {
          title: "Replace fleshly thoughts with spiritual.",
          slug: "replace-fleshly-thoughts",
          Component: ReplaceFleshlyThoughts,
        },
        {
          title: "Rejoice and give thanks for all of God's blessings.",
          slug: "rejoice-in-blessings",
          Component: RejoiceInBlessings,
        },
        {
          title: "Reverse the fleshly momentum; reorient your life in the Spirit.",
          slug: "reverse-momentum",
          Component: ReverseMomentum,
        },
      ],
    },
  ];